var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditV3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6668 3.82666C13.6673 3.73892 13.6505 3.65194 13.6174 3.57072C13.5842 3.48949 13.5353 3.41562 13.4735 3.35332L10.6468 0.526657C10.5845 0.46487 10.5107 0.415986 10.4294 0.38281C10.3482 0.349634 10.2612 0.332817 10.1735 0.333324C10.0858 0.332817 9.99879 0.349634 9.91757 0.38281C9.83634 0.415986 9.76247 0.46487 9.70017 0.526657L7.81351 2.41332L0.526841 9.69999C0.465053 9.76228 0.416169 9.83616 0.382993 9.91739C0.349817 9.99861 0.333 10.0856 0.333507 10.1733V13C0.333507 13.1768 0.403745 13.3464 0.528769 13.4714C0.653794 13.5964 0.823363 13.6667 1.00017 13.6667H3.82684C3.92013 13.6717 4.01344 13.6571 4.10072 13.6238C4.188 13.5905 4.26731 13.5393 4.33351 13.4733L11.5802 6.18666L13.4735 4.33332C13.5344 4.26871 13.5839 4.19435 13.6202 4.11332C13.6266 4.06018 13.6266 4.00646 13.6202 3.95332C13.6233 3.92229 13.6233 3.89102 13.6202 3.85999L13.6668 3.82666ZM3.55351 12.3333H1.66684V10.4467L8.28684 3.82666L10.1735 5.71332L3.55351 12.3333ZM11.1135 4.77332L9.22684 2.88666L10.1735 1.94666L12.0535 3.82666L11.1135 4.77332Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditV3);
export default __webpack_public_path__ + "static/media/editV3.1397e3f9.svg";
export { ForwardRef as ReactComponent };